import React, { useState } from 'react';

const CodeIcon = ({ width = 40, height = 40 }) => (

    <svg width={width} height={height}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Gradient Definitions */}
        <defs>
            {/* Background Gradient */}
            <linearGradient
                id="bgGradient2"
                x1="0"
                y1="0"
                x2="80"
                y2="80"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0%" stopColor="#FF9800" />
                <stop offset="100%" stopColor="#E65100" />
            </linearGradient>

            {/* Inner Glow Gradient for Code Symbols */}
            <radialGradient id="iconGlow" cx="0.5" cy="0.5" r="0.6">
                <stop offset="0%" stopColor="white" stopOpacity="1" />
                <stop offset="100%" stopColor="white" stopOpacity="0.7" />
            </radialGradient>
            <radialGradient id="gradTomato" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#FF6347', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#CC4F3A', stopOpacity: 1 }} />
            </radialGradient>
        </defs>

        {/* Background (No Outline, Just a Gradient) */}
        <rect width="80" height="80" rx="10" fill="url(#bgGradient2)" />

        {/* Code Symbols with Subtle Glow Effect */}
        <path
            d="M20 40H60"
            stroke="url(#iconGlow)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="1"
        />
        <path
            d="M30 28L20 40L30 52"
            stroke="url(#iconGlow)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="1"
        />
        <path
            d="M50 28L60 40L50 52"
            stroke="url(#iconGlow)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="1"
        />
    </svg>

);

const DataIcon = ({ width = 40, height = 40 }) => (

    <svg width={width} height={height}
        viewBox="-10 -10 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Gradient Definitions */}
        <defs>
            {/* Background Gradient */}
            <linearGradient
                id="bgGradient1"
                x1="0"
                y1="0"
                x2="80"
                y2="80"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0%" stopColor="#76D275" />
                <stop offset="100%" stopColor="#2E7D32" />
            </linearGradient>

            {/* Node Gradient */}
            <radialGradient id="nodeGradient" cx="0.5" cy="0.5" r="0.6">
                <stop offset="0%" stopColor="white" />
                <stop offset="100%" stopColor="#D4E157" />
            </radialGradient>
            <radialGradient id="gradLimeGreen" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#32CD32', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#28A828', stopOpacity: 1 }} />
            </radialGradient>
        </defs>

        {/* Background with Gradient */}
        <rect
            x="-10"
            y="-10"
            width="80"
            height="80"
            rx="10"
            fill="url(#gradLimeGreen)"
        />

        {/* Data Nodes with Gradient Fill */}
        <circle
            cx="20"
            cy="20"
            r="6"
            fill="url(#nodeGradient)"
            stroke="white"
            strokeWidth="2"
        />
        <circle
            cx="40"
            cy="20"
            r="6"
            fill="url(#nodeGradient)"
            stroke="white"
            strokeWidth="2"
        />
        <circle
            cx="30"
            cy="40"
            r="6"
            fill="url(#nodeGradient)"
            stroke="white"
            strokeWidth="2"
        />

        {/* Connecting Lines with Subtle Shadows */}
        <path
            d="M20 20L30 40L40 20"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            filter="url(#shadow)"
        />

        {/* Soft Drop Shadow */}
        <filter id="shadow" x="-5" y="-5" width="90" height="90">
            <feDropShadow
                dx="0"
                dy="2"
                stdDeviation="2"
                floodColor="black"
                floodOpacity="0.2"
            />
        </filter>
    </svg>
);

const DocIcon = ({ width = 40, height = 40 }) => (
    <svg width={width} height={height}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Background with Gradient */}
        <defs>
            <linearGradient
                id="bgGradient"
                x1="0"
                y1="0"
                x2="80"
                y2="80"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0%" stopColor="#5A9BFF" />
                <stop offset="100%" stopColor="#1E5ACB" />
            </linearGradient>
            <linearGradient
                id="docGradient"
                x1="22"
                y1="18"
                x2="58"
                y2="62"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.9" />
                <stop offset="100%" stopColor="#E4E9F2" />
            </linearGradient>
            <radialGradient id="gradDodgerBlue" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#1E90FF', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#176FCC', stopOpacity: 1 }} />
            </radialGradient>
        </defs>

        {/* Background */}
        <rect
            x="0"
            y="0"
            width="80"
            height="80"
            rx="10"
            fill="url(#gradDodgerBlue)"
        />

        {/* Document Shape with Shading */}
        <path
            d="M22 18H52L58 24V62H22V18Z"
            fill="url(#docGradient)"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* Page Fold Effect */}
        <path
            d="M52 18V24H58"
            fill="rgba(255, 255, 255, 0.8)"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* Soft Shadow for Depth */}
        <path
            d="M22 62H58"
            stroke="rgba(0,0,0,0.15)"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);

const TestCaseIcon = ({ width = 40, height = 40 }) => (
    <svg width={width} height={height}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Gradient Definitions */}
        <defs>
            {/* Background Gradient */}
            <linearGradient
                id="bgGradient3"
                x1="0"
                y1="0"
                x2="80"
                y2="80"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0%" stopColor="#8E24AA" />
                <stop offset="100%" stopColor="#6A1B9A" />
            </linearGradient>

            {/* Checkmark Glow */}
            <radialGradient id="checkGradient" cx="0.5" cy="0.5" r="0.7">
                <stop offset="0%" stopColor="white" stopOpacity="1" />
                <stop offset="100%" stopColor="white" stopOpacity="0.7" />
            </radialGradient>
        </defs>

        {/* Background */}
        <rect width="80" height="80" rx="10" fill="url(#bgGradient3)" />

        {/* Clipboard */}
        <rect
            x="20"
            y="18"
            width="40"
            height="50"
            rx="5"
            fill="#FFF"
            opacity="0.9"
        />
        <rect x="30" y="12" width="20" height="8" rx="3" fill="#EDE7F6" />

        {/* Test Steps */}
        <circle cx="28" cy="32" r="3" fill="#8E24AA" />
        <circle cx="28" cy="42" r="3" fill="#8E24AA" />
        <circle cx="28" cy="52" r="3" fill="#8E24AA" />
        <rect x="34" y="30" width="18" height="4" rx="2" fill="#B39DDB" />
        <rect x="34" y="40" width="24" height="4" rx="2" fill="#B39DDB" />
        <rect x="34" y="50" width="20" height="4" rx="2" fill="#B39DDB" />

        {/* Checkmark */}
        <path
            d="M24 52L30 58L44 44"
            stroke="url(#checkGradient)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const PromptsIcon = ({ width = 40, height = 40 }) => (
    <svg width={width} height={height}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Gradient Definitions */}
        <defs>
            {/* Background Gradient */}
            <linearGradient
                id="bgGradient4"
                x1="0"
                y1="0"
                x2="80"
                y2="80"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0%" stopColor="#FF6F61" />
                <stop offset="100%" stopColor="#D84315" />
            </linearGradient>

            {/* Inner Box Glow */}
            <radialGradient id="boxGlow" cx="0.5" cy="0.5" r="0.7">
                <stop offset="0%" stopColor="white" stopOpacity="0.9" />
                <stop offset="100%" stopColor="white" stopOpacity="0.7" />
            </radialGradient>

            <filter id="dropShadow" x="-10%" y="-0%" width="140%" height="140%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="1.7" />
                <feOffset dx="1" dy="1" result="offsetblur" />
                <feFlood floodColor="rgba(0,0,0,0.3)" />
                <feComposite in2="offsetblur" operator="in" />
                <feMerge>
                    <feMergeNode />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>

            <radialGradient id="gradGold" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#CCAC00', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradHotPink" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#FF69B4', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#CC528F', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradIndigo" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#4B0082', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#3A0066', stopOpacity: 1 }} />
            </radialGradient>
        </defs>

        {/* Background (No Outline, Just a Gradient) */}
        <rect width="80" height="80" rx="10" fill="url(#gradHotPink)" />

        {/* Nested Boxes with Soft Glow */}
        <path
            d="M20 20H60V60H20V20Z"
            stroke="url(#boxGlow)"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="0.95"
        />
        <path
            d="M26 26H54V54H26V26Z"
            stroke="url(#boxGlow)"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="0.95"
        />
        <path
            d="M34 34H46V46H34V34Z"
            stroke="url(#boxGlow)"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="0.95"
        />
    </svg>
);

const BookmarkIcon = ({ width = 40, height = 40 }) => (
    <svg width={width} height={height}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            {/* Background Gradient */}
            <linearGradient
                id="bgGradient4"
                x1="0"
                y1="0"
                x2="80"
                y2="80"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0%" stopColor="#FF6F61" />
                <stop offset="100%" stopColor="#D84315" />
            </linearGradient>

            {/* Inner Box Glow */}
            <radialGradient id="boxGlow" cx="0.5" cy="0.5" r="0.7">
                <stop offset="0%" stopColor="white" stopOpacity="0.9" />
                <stop offset="100%" stopColor="white" stopOpacity="0.7" />
            </radialGradient>

            <filter id="dropShadow" x="-10%" y="-0%" width="140%" height="140%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="1.7" />
                <feOffset dx="1" dy="1" result="offsetblur" />
                <feFlood floodColor="rgba(0,0,0,0.3)" />
                <feComposite in2="offsetblur" operator="in" />
                <feMerge>
                    <feMergeNode />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>

            <radialGradient id="gradGold" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#CCAC00', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradHotPink" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#FF69B4', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#CC528F', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradIndigo" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#4B0082', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#3A0066', stopOpacity: 1 }} />
            </radialGradient>
        </defs>

        {/* Background (No Outline, Just a Gradient) */}
        <rect width="80" height="80" rx="10" fill="url(#gradHotPink)" />

        {/* <circle cx="40" cy="40" r="30" fill="url(#gradHotPink)" opacity="0.5" /> */}

        {/* Bookmark Icon Shape */}
        <path
            d="M30 24C30 22.8954 30.8954 22 32 22H48C49.1046 22 50 22.8954 50 24V56L40 50L30 56V24Z"
            stroke="url(#boxGlow)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            opacity="1"
        />
    </svg>
);

const NewChatIcon = ({ width = 40, height = 40 }) => (
    <svg width={width} height={height}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <linearGradient
                id="bgGradientChat"
                x1="0"
                y1="0"
                x2="80"
                y2="80"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0%" stopColor="#42A5F5" />
                <stop offset="100%" stopColor="#1E88E5" />
            </linearGradient>

            <radialGradient id="boxGlow" cx="0.5" cy="0.5" r="0.7">
                <stop offset="0%" stopColor="white" stopOpacity="0.9" />
                <stop offset="100%" stopColor="white" stopOpacity="0.7" />
            </radialGradient>
        </defs>

        {/* Background */}
        <rect width="80" height="80" rx="10" fill="url(#bgGradientChat)" />

        {/* Chat Bubble Outline */}
        <path
            d="M20 24C20 21.7909 21.7909 20 24 20H56C58.2091 20 60 21.7909 60 24V46C60 48.2091 58.2091 50 56 50H32L24 58V50H24C21.7909 50 20 48.2091 20 46V24Z"
            stroke="url(#boxGlow)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="1"
        />

        {/* Plus Sign */}
        <line
            x1="40"
            y1="30"
            x2="40"
            y2="44"
            stroke="url(#boxGlow)"
            strokeWidth="4"
            strokeLinecap="round"
        />
        <line
            x1="32"
            y1="37"
            x2="48"
            y2="37"
            stroke="url(#boxGlow)"
            strokeWidth="4"
            strokeLinecap="round"
        />
    </svg>
);


const SimplePromptsIcon = () => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Gradient Definitions */}
        <defs>
            <linearGradient
                id="simpleBgGradient"
                x1="0"
                y1="0"
                x2="80"
                y2="80"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0%" stopColor="#B0BEC5" />
                <stop offset="100%" stopColor="#607D8B" />
            </linearGradient>
        </defs>

        {/* Background */}
        <rect width="80" height="80" rx="10" fill="url(#simpleBgGradient)" />

        {/* Nested Boxes */}
        <rect x="20" y="20" width="40" height="40" stroke="white" strokeWidth="3" fill="none" />

        {/* Play Arrow */}
        <polygon points="35,30 50,40 35,50" fill="white" />
    </svg>
);

const LightBulbIcon = () => (
    <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Gradient Definitions */}
        <defs>
            <linearGradient
                id="bulbGradient"
                x1="0"
                y1="0"
                x2="80"
                y2="80"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0%" stopColor="#FFEB3B" />
                <stop offset="100%" stopColor="#FFC107" />
            </linearGradient>
            <radialGradient id="glowGradient" cx="0.5" cy="0.5" r="0.7">
                <stop offset="0%" stopColor="white" stopOpacity="0.9" />
                <stop offset="100%" stopColor="white" stopOpacity="0.7" />
            </radialGradient>
        </defs>

        {/* Light Bulb Shape */}
        <path
            d="M40 10C28.9543 10 20 18.9543 20 30C20 37.732 24.804 44.126 31.5 46.5V55C31.5 56.3807 32.6193 57.5 34 57.5H46C47.3807 57.5 48.5 56.3807 48.5 55V46.5C55.196 44.126 60 37.732 60 30C60 18.9543 51.0457 10 40 10Z"
            fill="url(#bulbGradient)"
            stroke="black"
            strokeWidth="2"
        />

        {/* Light Bulb Base */}
        <rect
            x="32"
            y="57"
            width="16"
            height="10"
            rx="2"
            fill="#BDBDBD"
            stroke="black"
            strokeWidth="2"
        />

        {/* Light Bulb Filament */}
        <path d="M36 46H44" stroke="black" strokeWidth="2" strokeLinecap="round" />
        <path d="M38 50H42" stroke="black" strokeWidth="2" strokeLinecap="round" />

        {/* Light Glow */}
        <circle cx="40" cy="30" r="30" fill="url(#glowGradient)" opacity="0.5" />
    </svg>
);

const RackletLogo = () => (
    <svg
        width="200"
        height="200"
        viewBox="-20 -20 140 140" // Adjusted viewBox to include a larger area
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <filter id="dropShadow" x="-10%" y="-0%" width="140%" height="140%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="1.7" />
                <feOffset dx="1" dy="1" result="offsetblur" />
                <feFlood floodColor="rgba(0,0,0,0.3)" />
                <feComposite in2="offsetblur" operator="in" />
                <feMerge>
                    <feMergeNode />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
            <radialGradient id="gradTomato" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#FF6347', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#CC4F3A', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradDodgerBlue" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#1E90FF', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#176FCC', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradLimeGreen" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#32CD32', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#28A828', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradGold" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#CCAC00', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradHotPink" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#FF69B4', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#CC528F', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradIndigo" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#4B0082', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#3A0066', stopOpacity: 1 }} />
            </radialGradient>
            <style>
                {`
        @keyframes moveTomato {
            from { transform: translate(30px, 30px); opacity: 0; }
            to { transform: translate(0, 0); opacity: 1; }
        }
        @keyframes moveDodgerBlue {
            from { transform: translate(-30px, 30px); opacity: 0; }
            to { transform: translate(0, 0); opacity: 1; }
        }
        @keyframes moveLimeGreen {
            from { transform: translate(30px, -30px); opacity: 0; }
            to { transform: translate(0, 0); opacity: 1; }
        }
        @keyframes moveGold {
            from { transform: translate(-30px, -30px); opacity: 0; }
            to { transform: translate(0, 0); opacity: 1; }
        }
        @keyframes moveHotPink {
            from { transform: translate(30px, 30px); opacity: 0; }
            to { transform: translate(0, 0); opacity: 1; }
        }
        @keyframes moveIndigo {
            from { transform: translate(-30px, 30px); opacity: 0; }
            to { transform: translate(0, 0); opacity: 1; }
        }
        .animateTomato { animation: moveTomato 0.55s cubic-bezier(0.68, -0.55, 0.27, 1.55); }
        .animateDodgerBlue { animation: moveDodgerBlue 0.65s cubic-bezier(0.68, -0.55, 0.27, 1.55); }
        .animateLimeGreen { animation: moveLimeGreen 0.65s cubic-bezier(0.68, -0.55, 0.27, 1.55); }
        .animateGold { animation: moveGold 0.65s cubic-bezier(0.68, -0.55, 0.27, 1.55); }
        .animateHotPink { animation: moveHotPink 0.65s cubic-bezier(0.68, -0.55, 0.27, 1.55); }
        .animateIndigo { animation: moveIndigo 0.65s cubic-bezier(0.68, -0.55, 0.27, 1.55); }
    `}
            </style>
        </defs>
        <circle
            cx="30"
            cy="30"
            r="15"
            fill="url(#gradTomato)"
            filter="url(#dropShadow)"
            className="animateTomato"
        />{' '}
        {/* Tomato */}
        <circle
            cx="50"
            cy="30"
            r="15"
            fill="url(#gradDodgerBlue)"
            filter="url(#dropShadow)"
            className="animateDodgerBlue"
        />{' '}
        {/* Dodger Blue */}
        <circle
            cx="70"
            cy="30"
            r="15"
            fill="url(#gradLimeGreen)"
            filter="url(#dropShadow)"
            className="animateLimeGreen"
        />{' '}
        {/* Lime Green */}
        <circle
            cx="40"
            cy="50"
            r="15"
            fill="url(#gradGold)"
            filter="url(#dropShadow)"
            className="animateGold"
        />{' '}
        {/* Gold */}
        <circle
            cx="60"
            cy="50"
            r="15"
            fill="url(#gradHotPink)"
            filter="url(#dropShadow)"
            className="animateHotPink"
        />{' '}
        {/* Hot Pink */}
        <circle
            cx="50"
            cy="70"
            r="15"
            fill="url(#gradIndigo)"
            filter="url(#dropShadow)"
            className="animateIndigo"
        />{' '}
        {/* Indigo */}
    </svg>
);


const RackletLogov2 = () => (
    <svg
        width="200"
        height="200"
        viewBox="-20 -20 140 140" // Adjusted viewBox to include a larger area
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <filter id="dropShadow" x="-10%" y="-0%" width="140%" height="140%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="1.7" />
                <feOffset dx="1" dy="1" result="offsetblur" />
                <feFlood floodColor="rgba(0,0,0,0.3)" />
                <feComposite in2="offsetblur" operator="in" />
                <feMerge>
                    <feMergeNode />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
            <radialGradient id="gradTomato" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#FF6347', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#CC4F3A', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradDodgerBlue" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#1E90FF', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#176FCC', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradLimeGreen" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#32CD32', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#28A828', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradGold" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#CCAC00', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradHotPink" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#FF69B4', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#CC528F', stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradIndigo" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: '#4B0082', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#3A0066', stopOpacity: 1 }} />
            </radialGradient>
            <style>
                {`
        @keyframes rotateSquare {
            0% { transform: rotate(0deg); }
            90% { transform: rotate(360deg); }
            95% { transform: rotate(362deg); }
            100% { transform: rotate(360deg); }
        }
        .animateTomato rect, .animateTomato circle { 
            animation: rotateSquare 0.5s ease-in-out 1; 
            transform-origin: 30px 60px; /* Center of the square */
            animation-delay: 0.25s;
        }
        .animateDodgerBlue rect, .animateDodgerBlue circle { 
            animation: rotateSquare 0.5s ease-in-out 1; 
            transform-origin: 50px 60px; /* Center of the square */
            animation-delay: 0.20s;
        }
        .animateLimeGreen rect, .animateLimeGreen circle { 
            animation: rotateSquare 0.5s ease-in-out 1; 
            transform-origin: 70px 60px; /* Center of the square */
            animation-delay: 0.15s;
        }
        .animateGold rect, .animateGold circle { 
            animation: rotateSquare 0.5s ease-in-out 1; 
            transform-origin: 40px 70px; /* Center of the square */
            animation-delay: 0.10s;
        }
        .animateHotPink rect, .animateHotPink circle { 
            animation: rotateSquare 0.5s ease-in-out 1; 
            transform-origin: 60px 70px; /* Center of the square */
            animation-delay: 0.05s;
        }
        .animateIndigo rect, .animateIndigo circle { 
            animation: rotateSquare 0.5s ease-in-out 1; 
            transform-origin: 50px 80px; /* Center of the square */
            animation-delay: 0s;
        }
    `}
            </style>
        </defs>
        <g className="animateTomato">
            <rect x="15" y="45" width="12.5" height="12.5" fill="transparent" />
            <circle
                cx="30"
                cy="30"
                r="15"
                fill="url(#gradTomato)"
                filter="url(#dropShadow)"
            />
        </g>
        <g className="animateDodgerBlue">
            <rect x="35" y="45" width="13.75" height="13.75" fill="transparent" />
            <circle
                cx="50"
                cy="30"
                r="15"
                fill="url(#gradDodgerBlue)"
                filter="url(#dropShadow)"
            />
        </g>
        <g className="animateLimeGreen">
            <rect x="55" y="45" width="15" height="15" fill="transparent" />
            <circle
                cx="70"
                cy="30"
                r="15"
                fill="url(#gradLimeGreen)"
                filter="url(#dropShadow)"
            />
        </g>
        <g className="animateGold">
            <rect x="25" y="65" width="16.25" height="16.25" fill="transparent" />
            <circle
                cx="40"
                cy="50"
                r="15"
                fill="url(#gradGold)"
                filter="url(#dropShadow)"
            />
        </g>
        <g className="animateHotPink">
            <rect x="45" y="65" width="17.5" height="17.5" fill="transparent" />
            <circle
                cx="60"
                cy="50"
                r="15"
                fill="url(#gradHotPink)"
                filter="url(#dropShadow)"
            />
        </g>
        <g className="animateIndigo">
            <rect x="35" y="85" width="18.75" height="18.75" fill="transparent" />
            <circle
                cx="50"
                cy="70"
                r="15"
                fill="url(#gradIndigo)"
                filter="url(#dropShadow)"
            />
        </g>
    </svg>
);

const RackletLogov3 = () => {
    const [isAnimating, setIsAnimating] = useState(true);

    const handleClick = () => {
        setIsAnimating(!isAnimating);
    };

    return (
        <svg
            width="200"
            height="200"
            viewBox="-20 -20 140 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <filter id="dropShadow" x="-10%" y="-0%" width="140%" height="140%">
                    <feGaussianBlur in="SourceAlpha" stdDeviation="1.7" />
                    <feOffset dx="1" dy="1" result="offsetblur" />
                    <feFlood floodColor="rgba(0,0,0,0.3)" />
                    <feComposite in2="offsetblur" operator="in" />
                    <feMerge>
                        <feMergeNode />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
                <radialGradient id="gradTomato" cx="0.3" cy="0.3" r="0.7">
                    <stop offset="0%" style={{ stopColor: '#FF6347', stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: '#CC4F3A', stopOpacity: 1 }} />
                </radialGradient>
                <radialGradient id="gradDodgerBlue" cx="0.3" cy="0.3" r="0.7">
                    <stop offset="0%" style={{ stopColor: '#1E90FF', stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: '#176FCC', stopOpacity: 1 }} />
                </radialGradient>
                <radialGradient id="gradLimeGreen" cx="0.3" cy="0.3" r="0.7">
                    <stop offset="0%" style={{ stopColor: '#32CD32', stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: '#28A828', stopOpacity: 1 }} />
                </radialGradient>
                <radialGradient id="gradGold" cx="0.3" cy="0.3" r="0.7">
                    <stop offset="0%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: '#CCAC00', stopOpacity: 1 }} />
                </radialGradient>
                <radialGradient id="gradHotPink" cx="0.3" cy="0.3" r="0.7">
                    <stop offset="0%" style={{ stopColor: '#FF69B4', stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: '#CC528F', stopOpacity: 1 }} />
                </radialGradient>
                <radialGradient id="gradIndigo" cx="0.3" cy="0.3" r="0.7">
                    <stop offset="0%" style={{ stopColor: '#4B0082', stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: '#3A0066', stopOpacity: 1 }} />
                </radialGradient>
                <style>
                    {`
            @keyframes moveTomato {
                0% { transform: translate(0, 0) scale(1); }
                25% { transform: translate(30px, 15px) scale(0.8); }
                50% { transform: translate(0, 30px) scale(1); }
                75% { transform: translate(-30px, 15px) scale(0.8); }
                100% { transform: translate(0, 0) scale(1); }
            }
            @keyframes moveDodgerBlue {
                0% { transform: translate(0, 0) scale(1); }
                25% { transform: translate(-30px, 15px) scale(0.8); }
                50% { transform: translate(0, 30px) scale(1); }
                75% { transform: translate(30px, 15px) scale(0.8); }
                100% { transform: translate(0, 0) scale(1); }
            }
            @keyframes moveLimeGreen {
                0% { transform: translate(0, 0) scale(1); }
                25% { transform: translate(30px, -15px) scale(0.8); }
                50% { transform: translate(0, -30px) scale(1); }
                75% { transform: translate(-30px, -15px) scale(0.8); }
                100% { transform: translate(0, 0) scale(1); }
            }
            @keyframes moveGold {
                0% { transform: translate(0, 0) scale(1); }
                25% { transform: translate(-30px, -15px) scale(0.8); }
                50% { transform: translate(0, -30px) scale(1); }
                75% { transform: translate(30px, -15px) scale(0.8); }
                100% { transform: translate(0, 0) scale(1); }
            }
            @keyframes moveHotPink {
                0% { transform: translate(0, 0) scale(1); }
                25% { transform: translate(30px, 15px) scale(0.8); }
                50% { transform: translate(0, 30px) scale(1); }
                75% { transform: translate(-30px, 15px) scale(0.8); }
                100% { transform: translate(0, 0) scale(1); }
            }
            @keyframes moveIndigo {
                0% { transform: translate(0, 0) scale(1); }
                25% { transform: translate(-30px, 15px) scale(0.8); }
                50% { transform: translate(0, 30px) scale(1); }
                75% { transform: translate(30px, 15px) scale(0.8); }
                100% { transform: translate(0, 0) scale(1); }
            }
            .animateTomato { animation: moveTomato 2s cubic-bezier(0.25, 1.25, 0.75, -0.25) 1; animation-delay: 0s; }
            .animateDodgerBlue { animation: moveDodgerBlue 2s cubic-bezier(0.25, 1.25, 0.75, -0.25) 1; animation-delay: 0s; }
            .animateLimeGreen { animation: moveLimeGreen 2s cubic-bezier(0.25, 1.25, 0.75, -0.25) 1; animation-delay: 0s; }
            .animateGold { animation: moveGold 2s cubic-bezier(0.25, 1.25, 0.75, -0.25) 1; animation-delay: 0s; }
            .animateHotPink { animation: moveHotPink 2s cubic-bezier(0.25, 1.25, 0.75, -0.25) 1; animation-delay: 0s; }
            .animateIndigo { animation: moveIndigo 2s cubic-bezier(0.25, 1.25, 0.75, -0.25) 1; animation-delay: 0s; }
            .resetAnimation { animation: none; }
        `}
                </style>
            </defs>
            <circle
                cx="30"
                cy="30"
                r="15"
                fill="url(#gradTomato)"
                filter="url(#dropShadow)"
                className={isAnimating ? 'animateTomato' : 'resetAnimation'}
                onClick={handleClick}
            />{' '}
            {/* Tomato */}
            <circle
                cx="50"
                cy="30"
                r="15"
                fill="url(#gradDodgerBlue)"
                filter="url(#dropShadow)"
                className={isAnimating ? 'animateDodgerBlue' : 'resetAnimation'}
                onClick={handleClick}
            />{' '}
            {/* Dodger Blue */}
            <circle
                cx="70"
                cy="30"
                r="15"
                fill="url(#gradLimeGreen)"
                filter="url(#dropShadow)"
                className={isAnimating ? 'animateLimeGreen' : 'resetAnimation'}
                onClick={handleClick}
            />{' '}
            {/* Lime Green */}
            <circle
                cx="40"
                cy="50"
                r="15"
                fill="url(#gradGold)"
                filter="url(#dropShadow)"
                className={isAnimating ? 'animateGold' : 'resetAnimation'}
                onClick={handleClick}
            />{' '}
            {/* Gold */}
            <circle
                cx="60"
                cy="50"
                r="15"
                fill="url(#gradHotPink)"
                filter="url(#dropShadow)"
                className={isAnimating ? 'animateHotPink' : 'resetAnimation'}
                onClick={handleClick}
            />{' '}
            {/* Hot Pink */}
            <circle
                cx="50"
                cy="70"
                r="15"
                fill="url(#gradIndigo)"
                filter="url(#dropShadow)"
                className={isAnimating ? 'animateIndigo' : 'resetAnimation'}
                onClick={handleClick}
            />{' '}
            {/* Indigo */}
        </svg>
    );
};

const RackletLogoMini = () => (
    <svg
        width="40"
        height="40"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="30" cy="30" r="15" fill="#FF6347" /> {/* Tomato */}
        <circle cx="50" cy="30" r="15" fill="#1E90FF" /> {/* Dodger Blue */}
        <circle cx="70" cy="30" r="15" fill="#32CD32" /> {/* Lime Green */}
        <circle cx="40" cy="50" r="15" fill="#FFD700" /> {/* Gold */}
        <circle cx="60" cy="50" r="15" fill="#FF69B4" /> {/* Hot Pink */}
        <circle cx="50" cy="70" r="15" fill="#4B0082" /> {/* Indigo */}
    </svg>
);



export {
    CodeIcon,
    DataIcon,
    DocIcon,
    TestCaseIcon,
    PromptsIcon,
    BookmarkIcon,
    NewChatIcon,
    SimplePromptsIcon,
    LightBulbIcon,
    RackletLogo,
    RackletLogov2,
    RackletLogov3,
    RackletLogoMini
}
